import { classNames } from "@deathstar/ui";

export default function Subtitle({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) {
    return <p className={classNames("text-stone-500", className)} {...props} />;
}
